/**
 * Outbound webhook payload contracts. These are the v1 envelope + per-kind
 * data shapes that the backend producer signs and POSTs to subscribed
 * customer endpoints. Anything reachable here is part of the customer-facing
 * contract — backwards-incompatible changes require bumping `schema_version`
 * and a deprecation window.
 */
export const WEBHOOK_EVENT_KINDS = [
    "channel.message_posted",
    "channel.message_mentioned",
    "ticket.created",
    "ticket.phase_changed",
    "ticket.commented",
    "review.completed",
];
//# sourceMappingURL=webhooks.js.map